import { render, staticRenderFns } from "./redchirp-payment-method.vue?vue&type=template&id=18f34360&scoped=true&"
import script from "./redchirp-payment-method.vue?vue&type=script&lang=js&"
export * from "./redchirp-payment-method.vue?vue&type=script&lang=js&"
import style0 from "./redchirp-payment-method.vue?vue&type=style&index=0&id=18f34360&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f34360",
  null
  
)

export default component.exports